
 

 

 

 
class FileInfoData 
{
    
        Id: string;
    
        FileName: string;
    
        RelationId: string;
    
        RelationTypeValue: number;
    
        ExtensionId: string;
    
        Extension: string;
    
        Description: string;
    
        FilePath: string;
    
        FileByteData: any;
    
        MimeType: string;
    
}
 
export default FileInfoData;
 

